import { OrganizationSummary } from '@orgbrain/lib-admin';

// see also lib-mongoose/src/lib/admin-schaema.ts

export const URL_PARAM_SOURCE = 'source_key';
export const URL_PARAM_SOURCE_CREATOR = 'source_key_creator';

export class OnboardingOrderAlike {
  [URL_PARAM_SOURCE]?: string;
  overrideOrgbrainPricePerYear?: number;
  addingUpDurationMonthToSubscription?: number;
}

export class Order extends OnboardingOrderAlike {
  _id?: string;
  incomingOrderId: string;
  // new data
  parentOrgNumber: string;
  // original data
  selectedPackage?: string;
  source: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  orgNumber?: string;
  orgName: string;
  isPayingOrder?: boolean;
  payingOrderType?: PAYING_ORDER_TYPE;
  // PJL added for trial orders
  adminUserId?: string;
  processed?: boolean;
  fake?: boolean;

  // legacy from old form
  comments?: string;
  contactMeByPhoneFlag?: boolean;
  contactMeByEmailFlag?: boolean;

  // Auto generated by mongooseDB
  createdAt?: Date;
  updatedAt?: Date;

  // Transient stuff for admin
  duplicates?: Array<Order>;
  organization?: OrganizationSummary;
  orgIdTaken?: boolean;
  isOrgParent?: boolean;
  tooltipInfo?: string;
}

export class OrderResponse {
  success: boolean;
  orgNumber: string;
  order: Order;
}

export class IncomingOrderRecord {
  orgName: string;
  orgNo: string;
  adminFirstName: string;
  adminLastName: string;
  adminEmail: string;
  adminPhone: string;
}

export class MainOrganizationEntry {
  mainOrganization: IncomingOrderRecord;
  subsidiaryOrganizations: Array<IncomingOrderRecord>;
}

export enum OrderPayloadType {
  HOMEPAGE_SELECT_PACKAGE = 'HOMEPAGE_SELECT_PACKAGE',
  LANDING_PAGE_ORDER = 'LANDING_PAGE_ORDER',
  WORDPRESS_LANDING_PAGES = 'WORDPRESS_LANDING_PAGES',
  TRIAL_AUTO = 'TRIAL_AUTO',
  TRIAL_AUTO_BOARDSCHOOL = 'TRIAL_AUTO_BOARDSCHOOL',
  PAYING_ORDER_AUTO = 'PAYING_ORDER_AUTO',
  BOARDMATCH_USER_AUTOMATIC = 'BOARDMATCH_USER_AUTOMATIC',
}

export enum PAYING_ORDER_TYPE {
  PAING_ORDER_ANNUAL_GRUNDER = 'PAING_ORDER_ANNUAL_GRUNDER',
  PAING_ORDER_ANNUAL_SMALL_BUSINESS = 'PAING_ORDER_ANNUAL_SMALL_BUSINESS',
  PAING_ORDER_ANNUAL_BASIS = 'PAING_ORDER_ANNUAL_BASIS',
  PAING_ORDER_MONTHLY_GRUNDER = 'PAING_ORDER_MONTHLY_GRUNDER',
  PAING_ORDER_MONTHLY_SMALL_BUSINESS = 'PAING_ORDER_MONTHLY_SMALL_BUSINESS',
  PAING_ORDER_MONTHLY_BASIS = 'PAING_ORDER_MONTHLY_BASIS',
}

export class IncomingOrder {
  mainOrganizationEntries: Array<MainOrganizationEntry>;
}

// LEGACY. But still used in marketing stuff
export enum OrderSource {
  UNKNOWN = 'UNKNOWN',
  HOMEPAGE = 'HOMEPAGE',
  TRYG_LANDING = 'TRYG_LANDING',
  GA_CAMPAIGN_LANDING = 'GA_CAMPAIGN_LANDING',
  SMBNORGE_LANDING = 'SMBNORGE_LANDING',
  SNNREGNSKAP_LANDING = 'SNNREGNSKAP_LANDING',
}

export const orderSourceDescriptions = {
  UNKNOWN: 'Unknown source',
  HOMEPAGE: 'Home page',
  TRYG_LANDING: 'Tryg landing page',
  GA_CAMPAIGN_LANDING: 'GA campaign landing page',
  SMBNORGE_LANDING: 'SMB Norge landing page',
};

export const DEFAULT_CLIENT_ID = 'Orgbrain';
export const DEFAULT_ORDER_SOURCE_ID = OrderSource.HOMEPAGE;
